module.exports = __webpack_public_path__ + "static/media/img_product_banner.0d468773.png";